import styled from 'astroturf/react';
import { Link } from 'react-router-dom';

const footer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const link = styled(Link)`  
  font-family: var(--ph-font-family-source-sans-pro-regular);
  font-size: var(--ph-text-xss);
  color: var(--dark-blue);

  &:hover {
    text-decoration: underline !important;
    color: var(--dark-blue) !important;
  }
`;

export default { Footer: footer, Link: link };
